import { render, staticRenderFns } from "./SuburbLookup.vue?vue&type=template&id=4aeaca5e&scoped=true&"
import script from "./SuburbLookup.vue?vue&type=script&lang=ts&"
export * from "./SuburbLookup.vue?vue&type=script&lang=ts&"
import style0 from "./SuburbLookup.vue?vue&type=style&index=0&id=4aeaca5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeaca5e",
  null
  
)

export default component.exports